import styled from "styled-components"
import StyledContainer from "./styledContainer"

export const defaultTheme = {
    mode: 'day',
  
    basicWhite: '#ffffff',

    lightGrey: '#fafafa',
    basicGrey: '#f5f5f5',
    deepGrey: '#A0A3A7',

    lightBlack: '#767A7F',
    basicBlack: '#0A0A0A',

    lightPurple: '#EFEBFE',
    basicPurple: '#4D1DF7',


    leftBarBorder: '#CACCCE',
    navItemGrey: '#F2F2F2',
}

export const darkTheme = {
    mode: 'dark',
    
    basicWhite: '#0a0a0a',
    
    lightGrey: '#fafafa',
    basicGrey: '#f5f5f5',
    deepGrey: '#A0A3A7',

    lightBlack: '#767A7F',
    basicBlack: '#0A0A0A',

    lightPurple: '#EFEBFE',
    basicPurple: '#4D1DF7',

    leftBarBorder: '#CACCCE',
    navItemGrey: '#F2F2F2',
}

export const Row = styled(StyledContainer)`
    display: flex;
    align-items: center;
`

export const RowCenter = styled(StyledContainer)`
   display: flex;
   align-items: center;
   justify-content: center;
`

export const Column = styled(StyledContainer)`
    display: flex;
    flex-direction: column;
`

export const ColumnCenter = styled(StyledContainer)`
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
`